import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Table } from 'react-bootstrap';
import DimensionsRow from './DimensionsRow';
import VerbButton from '../../../../shared/components/VerbButton';

class DimensionsTable extends Component {
    static propTypes = {
        history: PropTypes.object,
        dimensions: PropTypes.array
    };

    renderTable = () => {
        const { dimensions } = this.props;

        return dimensions.map((dimension) => (
            <DimensionsRow key={dimension._id} history={this.props.history} dimension={dimension} />
        ));
    };

    render() {
        return (
            <div className={'dimensions-table'}>
                <div className={'generalControls col-12'}>
                    <VerbButton fontAwesomeIcon={'fa-plus'} onClick={() => this.props.history.push(`/newdimension`)}>
                        NEW DIMENSION
                    </VerbButton>
                </div>
                <Table striped={false} bordered={false} hover={true}>
                    <thead>
                        <tr>
                            <th className={'buttonCell'}>Actions</th>
                            <th>Dimension Name</th>
                            <th>Created On</th>
                        </tr>
                    </thead>
                    <tbody>{this.renderTable()}</tbody>
                </Table>
            </div>
        );
    }
}

export default DimensionsTable;
